export default "__VITE_ASSET__BTsgkPyf__"